import {createFeatureSelector, createSelector, MemoizedSelector} from '@ngrx/store';
import {DATA_SOURCE_DIMENSIONS_STATE_NAME, DataSourceDimensionsState} from "./dataSourceDimensions";
import {Serializers} from '../../interfaces/serializer';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';
import {DataSourceDimension} from '../../interfaces/dimensions';

export const selectDataSourceDimensionsState: MemoizedSelector<object, DataSourceDimensionsState> = createFeatureSelector<DataSourceDimensionsState>(DATA_SOURCE_DIMENSIONS_STATE_NAME);

export const selectDataSourceDimensions: MemoizedSelector<object, Serializers<DataSourceDimension>> = createSelector(
  selectDataSourceDimensionsState,
  (state: DataSourceDimensionsState): Serializers<DataSourceDimension> => state.serialized
);


export const selectDataSourceDimensionComponentObjects: MemoizedSelector<object, DimensionComponentObjects> = createSelector(
  selectDataSourceDimensionsState,
  (state: DataSourceDimensionsState): DimensionComponentObjects => state.componentObjects
);

export const selectDataSourceDimensionsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourceDimensionsState,
  (state: DataSourceDimensionsState): boolean => state.loading
);

export const selectDataSourceDimensionsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectDataSourceDimensionsState,
  (state: DataSourceDimensionsState): boolean => state.loaded
);
